import {Pipe, PipeTransform} from '@angular/core';

import {SubtitlesService} from "../core";

@Pipe({
    name: 'weekDay'
})
export class WeekDayPipe implements PipeTransform {
    constructor(
        private subtitles: SubtitlesService,
    ) {
    }
    transform(value: number): string {
        if (window.innerWidth <= 960) {

            switch (value) {
                case 0:
                    return this.subtitles.setSubtitle(445);
                case 1:
                    return this.subtitles.setSubtitle(590);
                case 2:
                    return this.subtitles.setSubtitle(894);
                case 3:
                    return this.subtitles.setSubtitle(708);
                case 4:
                    return this.subtitles.setSubtitle(235);
                case 5:
                    return this.subtitles.setSubtitle(516);
                case 6:
                    return this.subtitles.setSubtitle(703);
                case 7:
                    return this.subtitles.setSubtitle(588);
                case 8:
                    return this.subtitles.setSubtitle(701);
                default:
                    return '';
            }
        } else {
            switch (value) {
                case 0:
                    return this.subtitles.setSubtitle(444);
                case 1:
                    return this.subtitles.setSubtitle(589);
                case 2:
                    return this.subtitles.setSubtitle(893);
                case 3:
                    return this.subtitles.setSubtitle(707);
                case 4:
                    return this.subtitles.setSubtitle(234);
                case 5:
                    return this.subtitles.setSubtitle(515);
                case 6:
                    return this.subtitles.setSubtitle(702);
                case 7:
                    return this.subtitles.setSubtitle(588);
                case 8:
                    return this.subtitles.setSubtitle(701);
                default:
                    return '';
            }
        }
    }
}
